import { ItemSelectionTask } from './ItemSelectionTask/ItemSelectionTask';
import { RefundTask } from './RefundTask/RefundTask';
import { ReviewItemSummaryTask } from './ReviewItemSummaryTask/ReviewItemSummaryTask';
import { ReturnPolicyTask } from './ReturnPolicyTask/ReturnPolicyTask';
import type { TaskComponentMap } from '../../workflow/schemaTypes';
import { ReturnMethodForm } from './MethodTask/MethodTask';
import { ReasonsTask } from './ReasonsTask/ReasonsTask';
import { ResolutionTask } from './ResolutionTask/ResolutionTask';
import { ReviewRefundSummaryTask } from './ReviewRefundSummaryTask/ReviewRefundSummaryTask';
import { SignatureInput } from './SignatureTask/SignatureInput';
import { OrderlessTask } from './OrderlessTask/OrderlessTask';

export const taskComponentMap: TaskComponentMap = {
  itemSelection: ItemSelectionTask,
  returnMethod: ReturnMethodForm,
  reason: ReasonsTask,
  resolution: ResolutionTask,
  refund: RefundTask,
  reviewItemSummary: ReviewItemSummaryTask,
  reviewRefundSummary: ReviewRefundSummaryTask,
  returnPolicy: ReturnPolicyTask,
  signature: SignatureInput,
  orderlessCustomer: OrderlessTask,
};
